import {
  LloydsPenSvg,
  LloydsPostCoverSvg,
  LloydsFormSvg,
} from '../../assets/common';
import { AppContent } from '../AppContent';

// FullSignatoryPage content for LBG
const threeStepsToRegisterDelegateAccess: AppContent['threeStepsToRegisterDelegateAccess'] =
  {
    threeStepsToRegisterDelegateAccessContent: [
      {
        serviceName: 'Online for Business',
        header: 'Your three steps to register',
        description:
          'Follow these steps to register as a delegate access user:',
        registrationSteps: [
          {
            imageSrc: LloydsFormSvg,
            imageAlt: 'A form',
            stepHeading: 'Fill out the registration form',
            stepDescription: 'Enter some details about you and the business.',
          },
          {
            imageSrc: LloydsPenSvg,
            imageAlt: 'A Pen nib',
            stepHeading: 'Print, sign and collect signatures',
            stepDescription:
              'Sign the form and collect signatures from anyone who needs to approve your registration.',
          },
          {
            imageSrc: LloydsPostCoverSvg,
            imageAlt: 'A Post cover',
            stepHeading: 'Post the form back to us',
            stepDescription:
              'We’ll let you know when we’ve received your form and we’re working on your request.',
          },
        ],
        nextBtn: 'Continue',
        nextBtnHref:
          'https://onlinebusiness.lloydsbank.co.uk/business/a/registration/selectRegistrationType.jsp',
        previousLink: 'Previous',
        previousHref: '/full-signatory',
      },
    ],
  };

export default threeStepsToRegisterDelegateAccess;
